//
// Tokens that will be whitelisted in the swap UI
//

export const WHITELIST = {

	// BSC whitelist
	56: [
		{
			name: 'Binance Token',
			symbol: 'BNB',
			address: 'eth',
			description: 'Native token of Binance Smart Chain'
		},
		{
			name: 'TOAD Network',
			symbol: 'TOAD',
			address: '0x463E737D8F740395ABf44f7aac2D9531D8D539E9',
			description: 'PadSwap governance token'
		},
		{
			name: 'Lily PAD',
			symbol: 'PAD',
			address: '0xC0888d80EE0AbF84563168b3182650c0AdDEb6d5',
			description: 'PadSwap farm reward token'
		},
	 	{
      name: 'WBNB Token',
      symbol: 'WBNB',
      address: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c', 
      description: 'Wrapped BNB'
  	},
    {
      name: 'BUSD Token',
      symbol: 'BUSD',
      address: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
      description: 'Binance\'s Stablecoin'
  	},
    {
      name: 'Ethereum Token',
      symbol: 'ETH',
      address: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
      description: 'Binance-wrapped Ethereum token'
    },
    {
      name: 'BTCB Token',
      symbol: 'BTCB',
      address: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
      description: 'Binance-wrapped Bitcoin'
    },
    {
      name: 'USD Coin',
      symbol: 'USDC',
      address: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
      description: 'Binance-wrapped USDC stablecoin`'
    },
    {
      name: 'Hoge.Finance',
      symbol: 'HOGE',
      address: '0xa4FFfc757e8c4F24E7b209C033c123D20983Ad40',
      description: 'Wrapped HOGE token, bridged from Ethereum'
    },
    {
      name: 'PARADOX NFT BSC',
      symbol: 'PXBSC',
      address: '0xa4cfe5ea184a9a8bb2bb8377a378606a36ddea80',
      description: ''
    },
    {
      name: 'FUCK YOU KARENS',
      symbol: 'FUK',
      address: '0xa898bbb508c04be26af3d319b7775927afcb02af',
      description: ''
    },
    {
      name: 'GALLANT',
      symbol: 'GAL',
      address: '0x580655e2c6d4fc125c0b2d37b2a3e56219bf9f78',
      description: ''
    },
    {
      name: 'CATOSHI BSC',
      symbol: 'CZATS',
      address: '0x56747ed2fca81b25fae112c7a9d4465e947aac56',
      description: ''
    },
    {
      name: 'Tether USD',
      symbol: 'USDT',
      address: '0x55d398326f99059fF775485246999027B3197955',
      description: ''
    },
    {
      name: 'DOGE',
      symbol: 'DOGE',
      address: '0xbA2aE424d960c26247Dd6c32edC70B295c744C43',
      description: ''
    },
    {
      name: 'CARDANO',
      symbol: 'ADA',
      address: '0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47',
      description: ''
    },
    {
      name: 'POLKADOT',
      symbol: 'DOT',
      address: '0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402',
      description: ''
    },
    {
      name: 'KISHIMOTO INU',
      symbol: 'KISH',
      address: '0xCAb599D699f818e6ceFd07cF54f448DAB9367B05',
      description: ''
    },
    {
      name: 'Swamp King Capital',
      symbol: 'SKC',
      address: '0x18e68f649f27719c185ae3d13098163336ec2f8c',
      description: ''
	  }
	],


	// Moonbeam whitelist
	1284: [
		{
			address: 'eth',
			symbol: 'GLMR',
			name: 'Glimmer Token',
			description: 'Native token of Moonbeam Chain'
		},
		{
			address: '0xF480f38C366dAaC4305dC484b2Ad7a496FF00CeA',
			symbol: 'TOAD',
			name: 'TOAD Network',
			description: 'PadSwap governance token'
		},
		{
			address: '0x59193512877E2EC3bB27C178A8888Cfac62FB32D',
			symbol: 'PAD',
			name: 'Lily PAD',
			description: 'PadSwap farm reward token'
		},
    {
      name: "xEther",
      symbol: "xETH",
      address: "0x30D2a9F5FDf90ACe8c17952cbb4eE48a55D916A7",
      description: 'Ethereum token, bridged through Nomad'
    },
    {
      name: "anyEther",
      symbol: "anyETH",
      address: "0xfA9343C3897324496A05fC75abeD6bAC29f8A40f",
      description: 'Ethereum token, bridged through Multichain (aka Anyswap)'
    },
    {
      name: "Dai Stablecoin",
      symbol: "xDAI",
      address: "0xc234A67a4F840E61adE794be47de455361b52413",
      description: 'DAI Stablecoin, bridged through Nomad'
    },
    {
      name: "Tether USD",
      symbol: "xUSDT",
      address: "0x8e70cd5b4ff3f62659049e74b6649c6603a0e594",
      description: 'USDT Stablecoin, bridged through Nomad'
    },
    {
      name: "USD Coin",
      symbol: "xUSDC",
      address: "0x8f552a71EFE5eeFc207Bf75485b356A0b3f01eC9",
      description: 'USDC Stablecoin, bridged through Nomad'
    },
    {
      name: "USD Coin",
      symbol: "anyUSDC",
      address: "0x818ec0A7Fe18Ff94269904fCED6AE3DaE6d6dC0b",
      description: 'USDC Stablecoin, bridged through Multichain (aka Anyswap)'
    },
    {
      name: "Binance Coin",
      symbol: "anyBNB",
      address: "0xc9BAA8cfdDe8E328787E29b4B078abf2DaDc2055",
      description: 'BNB token, bridged through Multichain (aka Anyswap)'
    },
    {
      name: "BUSD",
      symbol: "anyBUSD",
      address: "0xA649325Aa7C5093d12D6F98EB4378deAe68CE23F",
      description: 'BUSD Stablecoin, bridged through Multichain (aka Anyswap)'
    },
    {
      name: "Wrapped Glimmer",
      symbol: "WGLMR",
      address: "0xe3DB50049C74De2F7d7269823af3178Cf22fd5E3",
      description: ''
    },
    {
      name: "Avalanche",
      symbol: "anyAVAX",
      address: "0x4792C1EcB969B036eb51330c63bD27899A13D84e",
      description: ''
    }
	],


	// Moonriver whitelist
	1285: [
		{
			address: 'eth',
			symbol: 'MOVR',
			name: 'Moonriver Token',
			description: 'Native token of Moonriver Chain'
		},
		{
			address: '0x165DBb08de0476271714952C3C1F068693bd60D7',
			symbol: 'TOAD',
			name: 'TOAD Network',
			description: 'PadSwap governance token'
		},
		{
			address: '0x45488C50184Ce2092756ba7CdF85731fD17e6f3d',
			symbol: 'PAD',
			name: 'Lily PAD',
			description: 'PadSwap farm reward token'
		},
		{
			address: '0xE3F5a90F9cb311505cd691a46596599aA1A0AD7D',
			symbol: 'USDC',
			name: 'Multichain USDC',
			description: 'USDC stablecoin, bridged through Multichain bridge'
		},
    {
      name: "Binance USD",
      symbol: "BUSD",
      address: "0x5D9ab5522c64E1F6ef5e3627ECCc093f56167818",
      description: 'BUSD Stablecoin, bridged through Multichain bridge'
    },
    {
      name: "Tether USD",
      symbol: "USDT",
      address: "0xB44a9B6905aF7c801311e8F4E76932ee959c663C",
      description: 'USDT Stablecoin, bridged through Multichain bridge'
    },
    {
      name: "DAI Stablecoin",
      symbol: "DAI",
      address: "0x80A16016cC4A2E6a2CACA8a4a498b1699fF0f844",
      description: 'DAI token, bridged through Multichain bridge'
    },
    {
      name: "Magic Internet Money",
      symbol: "MIM",
      address: "0x0caE51e1032e8461f4806e26332c030E34De3aDb",
      description: 'MIM token, bridged through Multichain bridge'
    },
    {
      name: "Binance Coin",
      symbol: "BNB",
      address: "0x2bF9b864cdc97b08B6D79ad4663e71B8aB65c45c",
      description: 'Native token of BSC, bridged through Multichain bridge'
    },
    {
      name: "River Doge",
      symbol: "RIVERDOGE",
      address: "0x5D4360f1Be94bD6f182F09cFE5EF9832e65EB1ac",
      description: ''
    },
    {
      name: "FRAX",
      symbol: "FRAX",
      address: "0x1A93B23281CC1CDE4C4741353F3064709A16197d",
      description: ''
    },
    {
      name: "ROME DAO",
      symbol: "ROME",
      address: "0x4a436073552044D5f2f49B176853ad3Ad473d9d6",
      description: ''
    }
	]
}



// Default trades that will initially show up on the swap page
export const DEFAULT_SWAP_ROUTES = {
	// BSC
	56: {
		inputToken: {
			address: 'eth',
			symbol: 'BNB',
			name: 'Binance Token',
			description: 'Native token of Binance Smart Chain'
		},
		outputToken: {
			address: '0x463E737D8F740395ABf44f7aac2D9531D8D539E9',
			symbol: 'TOAD',
			name: 'TOAD Network',
			description: 'PadSwap governance token'
		}
	},


	// Moonbeam
	1284: {
		inputToken: {
			address: 'eth',
			symbol: 'GLMR',
			name: 'Glimmer Token',
			description: 'Native token of Moonbeam Chain'
		},
		outputToken: {
			address: '0xF480f38C366dAaC4305dC484b2Ad7a496FF00CeA',
			symbol: 'TOAD',
			name: 'TOAD Network',
			description: 'PadSwap governance token'
		}
	},


	// Moonriver
	1285: {
		inputToken: {
			address: 'eth',
			symbol: 'MOVR',
			name: 'Moonriver Token',
			description: 'Native token of Moonriver Chain'
		},
		outputToken: {
			address: '0x165DBb08de0476271714952C3C1F068693bd60D7',
			symbol: 'TOAD',
			name: 'TOAD Network',
			description: 'PadSwap governance token'
		}
	}
}
